import { useEffect, useRef } from 'react';
var MAX_RETRIES = 5;
var useWebSocket = function (_a) {
    var url = _a.url, onMessage = _a.onMessage, enabled = _a.enabled;
    var ws = useRef(null);
    var onMessageRef = useRef(onMessage);
    var heartbeatInterval = useRef(null);
    var reconnectTimeout = useRef(null);
    var manuallyClosed = useRef(false);
    var retryCount = useRef(0);
    useEffect(function () {
        onMessageRef.current = onMessage;
    }, [onMessage]);
    useEffect(function () {
        if (!url || !enabled)
            return;
        var stopTimers = function () {
            if (heartbeatInterval.current)
                clearInterval(heartbeatInterval.current);
            if (reconnectTimeout.current)
                clearTimeout(reconnectTimeout.current);
            heartbeatInterval.current = null;
            reconnectTimeout.current = null;
        };
        var connect = function () {
            console.log('WS Connecting to:', url);
            manuallyClosed.current = false;
            var socket = new WebSocket(url);
            ws.current = socket;
            socket.onopen = function () {
                retryCount.current = 0;
                console.log('WS Connected');
                stopTimers();
                // Heartbeat every 30s to keep AWS/LoadBalancer happy
                heartbeatInterval.current = setInterval(function () {
                    if (socket.readyState === WebSocket.OPEN) {
                        console.log('WS Heartbeat Ping');
                        socket.send(JSON.stringify({ action: 'ping' }));
                    }
                }, 30000);
            };
            socket.onmessage = function (event) {
                try {
                    var data = JSON.parse(event.data);
                    if (data.message === 'pong') {
                        console.log('WS Heartbeat pong');
                        return;
                    }
                }
                catch (e) { }
                onMessageRef.current(event);
            };
            socket.onclose = function (e) {
                console.log("WS Closed: code-".concat(e.code, " --- reason-").concat(e.reason));
                stopTimers();
                if (!manuallyClosed.current &&
                    enabled &&
                    retryCount.current < MAX_RETRIES) {
                    reconnectTimeout.current = setTimeout(function () {
                        retryCount.current++;
                        connect();
                    }, 2000);
                }
            };
            socket.onerror = function (err) { return console.error('WS Error:', err); };
        };
        connect();
        return function () {
            console.log('WS Cleanup');
            manuallyClosed.current = true;
            stopTimers();
            if (ws.current) {
                if (ws.current.readyState === WebSocket.OPEN ||
                    ws.current.readyState === WebSocket.CONNECTING) {
                    try {
                        ws.current.close();
                        console.log('WS close successfully');
                    }
                    catch (error) {
                        console.log('WS Failed to close');
                    }
                }
            }
            ws.current = null;
        };
    }, [url, enabled]);
    return {};
};
export default useWebSocket;
